export default {
  path: '/reports/report-by-person',
  name: 'ReportByPerson',
  component: () => import('../views/ReportByPerson'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
